/* eslint-disable import/first */

import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';

import LocaleProvider from 'antd/lib/locale-provider';
import antdEnGB from 'antd/lib/locale-provider/en_GB';

import moment from 'moment';
import 'moment/locale/en-gb';

// import Helmet from 'react-helmet';

import { Link } from 'react-router-dom';

import { stringify as stringifyQuery } from 'querystring';

// import { IntercomProvider } from 'react-use-intercom';

import './helpers/library';

import 'hive-admin/src/components/FieldGooglePolygon';
import 'hive-admin/src/components/FieldWYSIWYG';
import 'hive-admin/src/components/FieldCodeEditor';
import 'hive-admin/src/components/FieldWYSIWYGDecorator'

import Admin from './components/Admin';

import './antd.less';
import './admin.less';

import './components/PageArchiveTable.less';
import './components/PageArchiveGrid.less';

import './components/ActionCreate';
import './components/ActionDelete';
import './components/ActionSave';
import './components/ActionSaveAndReload';
import './components/ActionSidebar';
import './components/FieldChangeLog';
import './components/FieldTextAreaMonospace';
import './components/FieldUploadRefsDropzone';
import './components/FieldWorkingHours';
// import './components/FieldGoogleAddress';
import './components/FieldTable';
import './components/FieldRadioVertical';
import './components/FieldRichText';
import './components/FieldColorPicker';
import './components/FieldConnectionSelect';
import './components/FieldRadioAdvanced';
import './components/PageArchiveTable';
import './components/PageArchiveTableSelectable';
import './components/FieldRadio';
import './components/FieldSlug';
import './components/FilterPagination';
import './components/FieldWYSIWYGPostLinkToolbarItem';

import UserPages from './routes/users';
// import LibraryPages from './routes/library';
// import PagesPages from './routes/pages';
// import OrdersPages from './routes/orders';
// import SettingsGroup from './routes/settings';
// import ShowsPages from './routes/shows';
import DevelopmentPage from './routes/development';
import TagsPages from './routes/tags';
import CategoriesPages from './routes/categories';
import PostsPages from './routes/posts'
import LibraryPages from './routes/library';

import theme from './theme';

import { renderLogo, renderSidebarLogo } from './components/Logo';

import packageJson from '../package.json';

moment.locale('en-gb');

const {
  REACT_APP_SERVER_HOST,
  REACT_APP_SERVER_PROTOCOL,
  REACT_APP_HTTP_PORT,
  REACT_APP_API_PATH,
  REACT_APP_PUBLIC_URL = '',
  // REACT_APP_DXTOOLS_ENV_SYMBOL = '',
} = process.env;

const SERVER_URL = `${
  REACT_APP_SERVER_PROTOCOL
}://${
  REACT_APP_SERVER_HOST
}${
  REACT_APP_HTTP_PORT === '80' ? '' : `:${REACT_APP_HTTP_PORT}`
}`;

const base = window.ADMIN_BASE = `${REACT_APP_PUBLIC_URL}`;
const restBase = (
  REACT_APP_HTTP_PORT === '80'
  ? `${SERVER_URL}${REACT_APP_API_PATH}`
  : `${REACT_APP_API_PATH}`
);

const admin = Admin.create({
  base,
  restBase,
  restBaseServer: `${SERVER_URL}${REACT_APP_API_PATH}`,
  validateViewer: async (viewer, props) => {
    await Promise.all([
      (async () => {
        if (viewer) {
          viewer.settings = await (
            props.client
            .get(`/settings/general?${stringifyQuery({
              //
            })}`)
            .then(res => res.data)
          );
        }
      })(),
      // (async () => {
      //   if (viewer) {
      //     viewer.languages = await (
      //       props.client
      //       .get('/languages')
      //       .then(res => res.data?.data)
      //     );
      //   }
      // })(),
    ]);
    window.VIEWER = viewer;
    return viewer;
  },
  sidebarProps: { renderLogo: renderSidebarLogo },
  passwordSetSuccessRedirectPath: '/login',
  accountActivationSuccessRedirectPath: '/login',
  clientVersion: packageJson.version,
  clientHeaderKeys: {
    CLIENT_VERSION: 'X-Platform-Version',
  },
  structure: [
    ['PageLogin', {
      renderBeforeForm: renderLogo,
      redirect: [['redirect.authorized']],
      renderAfterForm: props => (
        <>
          <p className="after-form" style={{ marginBottom: '0.3em' }}>
            Lost your password? Click
            {' '}
            <Link to={props.passwordResetPath}>
              here
            </Link>
            {' '}
            to set a new one.
          </p>
          <p className="after-form">
            If you dont yet have an account, click
            {' '}
            <a href="/signup">
              here
            </a>
            {' '}
            to signup.
          </p>
        </>
      ),
    }],
    ['Page', {
      hidden: true,
      path: '/',
      exact: true,
      redirect: [
        ['redirect.always', '/users/me'],
      ],
    }],
    ['PagePasswordReset', {
      renderBeforeForm: renderLogo,
      redirect: [['redirect.authorized']],
    }],
    ['PagePasswordSet', {
      renderBeforeForm: renderLogo,
      base: '',
    }],
    ['PageAccountActivation', {
      renderBeforeForm: renderLogo,
      base: '',
    }],
    // ...PagesPages,
    // ...ShowsPages,
    // ...OrdersPages,
    ...LibraryPages,
    ...CategoriesPages,
    ...TagsPages,
    ...PostsPages,
    ...UserPages,
    // ...LibraryPages[1].pages,
    // // ...LanguagePages,
    // SettingsGroup,
    // DevelopmentPage,
    ['Page404', {
      redirect: [
        ['redirect.unauthorized'],
      ],
    }],
  ],
});

ReactDOM.render(
  (
    <LocaleProvider locale={antdEnGB}>
      <ThemeProvider theme={theme}>
        {admin}
      </ThemeProvider>
    </LocaleProvider>
  ),
  document.getElementById('root'),
);
